import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import { RouterTextLink } from "components/actions/RouterLink";
import { TableCell } from "components/table_components/TableCellStyles";
import EllipsisTooltip from "components/ui/tooltip/EllipsisTooltip";
import { appRoutes } from "lib/appRoutes";

type Props = {
  frameworks: { id: string; title?: string | null }[];
};

export default function FrameworkLinkCell({ frameworks }: Props): JSX.Element {
  return (
    <TableCell minWidth={100}>
      {frameworks.length > 0
        ? frameworks.map((framework) => (
            <EllipsisTooltip key={framework.id} fullText={framework.title ?? ""}>
              {(ref) => (
                <LinkWrapper>
                  <RouterTextLink ref={ref} ellipsis {...appRoutes.frameworkDetail(framework.id)}>
                    {framework.title ?? ""}
                  </RouterTextLink>
                </LinkWrapper>
              )}
            </EllipsisTooltip>
          ))
        : "--"}
    </TableCell>
  );
}

const LinkWrapper = styled(Flex)({
  overflow: "hidden",
  whiteSpace: "nowrap",
  minWidth: 0,
});
